import type { TaskSuccess } from '@camino-solutions/share/proto/common/services';

export class SessionTaskProcessingTaskSuccessAction {
  static readonly type = '[Session] Task processing: TaskSuccess';

  constructor(
    readonly cardId: string,
    readonly taskSuccess: TaskSuccess,
  ) {}
}
